export default __webpack_public_path__ + "static/media/ss.2cb7ad41.svg";